import { useQuery } from '@tanstack/vue-query'
import { getPortfolioHoldingsSummary } from '../portfolioEndpoints'
import { portfolioKeys } from '../portfolioQueryKeys'

export function usePortfolioHoldingsSummaryQuery() {
  return useQuery({
    queryKey: portfolioKeys.holdingsSummary(),
    queryFn: getPortfolioHoldingsSummary,
  })
}
